import { render, staticRenderFns } from "./ot-project-user-contracts-index.vue?vue&type=template&id=7570c464&scoped=true&"
import script from "./ot-project-user-contracts-index.vue?vue&type=script&lang=ts&"
export * from "./ot-project-user-contracts-index.vue?vue&type=script&lang=ts&"
import style0 from "./ot-project-user-contracts-index.vue?vue&type=style&index=0&id=7570c464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7570c464",
  null
  
)

export default component.exports